import '../../shared/layout/header/header.scss';

import { DarkMode, MoreVert, TimeToLeave, WbSunny } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, ButtonGroup, Menu, MenuItem, Tooltip } from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import InProductionButton from 'app/shared/components/do-not-show-in-production/in-production-button.component';
import { useAppThemeContext } from 'app/shared/contexts/ThemeContext';
import * as React from 'react';
import { useState } from 'react';
import { Translate } from 'react-jhipster';
import { Link, useLocation } from 'react-router-dom';

export interface IHeaderProps {
  ribbonEnv: string;
  isInProduction: boolean;
  open: boolean;
  setOpen?: (value: boolean) => void;
}

const drawerWidth = 280;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const ChecklistFacilHeader = (props: IHeaderProps) => {
  const location = useLocation();
  const { themeName, toggleTheme } = useAppThemeContext();
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;
  const logoChecklistFacil =
    initialTheme === 'light'
      ? '../../../content/images/checklist-facil/logo-checklistfacil-default.png'
      : '../../../content/images/checklist-facil/logo-checklistfacil-white.png';

  const isActive = url => {
    return location.pathname === url;
  };
  const handleDrawer = () => {
    props.setOpen(!props.open);
  };
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  function changeLogo() {
    return (
      <Link to="/dashboards">
        <img src={logoChecklistFacil} alt="Checklist Fácil" style={{ width: '160px', cursor: 'pointer' }} />
      </Link>
    );
  }

  const defaultButtonHeaderStyles =
    initialTheme === 'dark'
      ? {
          mr: '40px',
          px: '20px',
          textTransform: 'none',
          borderRadius: '0px',
          '&:hover': {
            color: '#D5D5D5',
          },
        }
      : {
          mr: '40px',
          px: '20px',
          textTransform: 'none',
          opacity: '50%',
          borderRadius: '0px',
          color: '#000814',
          '&:hover': {
            color: '#000814',
            opacity: '100%',
          },
        };

  const activeButtonStylesHeader = {
    opacity: '100%',
    borderBottom: themeName === 'dark' ? 'solid #00EA80 4px' : 'solid #000814 4px',
    backgroundImage:
      themeName === 'dark' ? 'linear-gradient(rgba(6, 13, 31, 0.5), rgba(6, 13, 31, 0.5))' : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))',
    color: themeName === 'dark' ? '#D5D5D5' : '#000814',
  };

  return (
    <>
      <AppBar position="sticky" open={props.open} sx={{ backgroundImage: 'none', backgroundColor: 'primary.main' }}>
        <Toolbar
          sx={{
            paddingLeft: { xs: '0px', md: '24px' },
            paddingRight: { xs: '0px', md: '24px' },
          }}
        >
          {/* {renderDevRibbon()} */}
          {!props.open && (
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleDrawer}
                color={themeName === 'dark' ? 'inherit' : 'primary'}
                sx={{
                  ...defaultButtonHeaderStyles,
                  marginRight: '0px',
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          )}
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>{!props.open && changeLogo()}</Box>
          <ButtonGroup sx={{ px: '24px' }}>
            <Tooltip title={themeName === 'light' ? 'Modo Escuro' : 'Modo Claro'} placement="bottom">
              <IconButton size="small" onClick={toggleTheme} color="secondary">
                {themeName === 'light' ? <DarkMode sx={{ opacity: '50%' }} /> : <WbSunny sx={{ fill: '#ABADC6' }} />}
              </IconButton>
            </Tooltip>
          </ButtonGroup>
          <InProductionButton />
          <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', height: '64px', display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color={themeName === 'dark' ? 'inherit' : 'primary'}
              sx={{
                display: { xs: 'none', md: 'block' },
                ...defaultButtonHeaderStyles,
                marginRight: '0px',
              }}
            >
              <MoreVert />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <MenuItem component={Link} to="/dashboards/company/truck-implements">
                <Typography fontWeight="500">
                  <Translate contentKey="global.menu.entities.asset">Assets</Translate>
                </Typography>
              </MenuItem>
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', height: '64px', display: { xs: 'none', md: 'flex' } }}>
            <Button
              component={Link}
              to="/dashboards/company/truck-implements"
              color={themeName === 'dark' ? 'inherit' : 'primary'}
              startIcon={<TimeToLeave sx={{ mr: '16px' }} />}
              sx={{
                ...defaultButtonHeaderStyles,
                ...(isActive('/') ? activeButtonStylesHeader : {}),
              }}
            >
              <Typography fontWeight="500">
                <Translate contentKey="global.menu.entities.asset">Assets</Translate>
              </Typography>
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};
